import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetaDirective } from './directives/object/meta.directive';
import { MetaFieldNameDirective } from './directives/object/meta-field-name.directive';
import { MetaFormatPipe } from './pipes/meta-format.pipe';
import { MetaFormDirective } from './directives/form/meta-form.directive';
import { MetaControlNameDirective } from './directives/form/meta-control-name.directive';
import { MetaLabelComponent } from './components/meta-label/meta-label.component';
import { MetaFieldComponent } from './components/meta-field/meta-field.component';

@NgModule({
  declarations: [],
  imports: [
    MetaFormatPipe,
    MetaDirective,
    MetaFieldNameDirective,
    MetaFormDirective,
    MetaControlNameDirective,
    MetaLabelComponent,
    MetaFieldComponent,
  ],
  providers: [
    MetaFormatPipe
  ],
  exports: [
    MetaFormatPipe,
    MetaDirective,
    MetaFieldNameDirective,
    MetaFormDirective,
    MetaControlNameDirective,
    MetaLabelComponent,
    MetaFieldComponent,
  ]
})
export class MetaModule { }
